import React from 'react';
import {  Users, Leaf, TrendingUp } from 'lucide-react';
import('../css/Mission.css')
const Mission = () => {
  return (
    <div className="about-page">
      <div className="hero-section">
        <div className="overlay"></div>
        <div className="hero-content">
          <h1>Welcome to KhetBazaar</h1>
          <p>Connecting Farmers to Consumers</p>
        </div>
      </div>

      <div className="stats-section">
        <div className="stats-container">
          <div className="stat-card">
            <Users className="icon" />
            <div className="stat-info">
              <h3>10,000+</h3>
              <p>Happy Customers</p>
            </div>
          </div>
          
          <div className="stat-card">
            <Leaf className="icon" />
            <div className="stat-info">
              <h3>5,000+</h3>
              <p>Farmers Connected</p>
            </div>
          </div>
          
          <div className="stat-card">
            <TrendingUp className="icon" />
            <div className="stat-info">
              <h3>10,000+</h3>
              <p>Land Listings</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mission-section">
        <div className="mission-content">
          <h2>Our Mission</h2>
          <p>KhetBazaar is revolutionizing land transactions by creating a seamless platform that connects landowners and buyers. We empower users to easily buy, sell, and lease properties through our trusted marketplace, making land dealings simple, transparent, and secure for everyone.</p>
        </div>
      </div>

    </div>
  );
};

export default Mission;